export const level30Wizards = {
    name: 'Level 30 Wizards',
    logo: {
        path: 'partners/level-30-wizards-logo-white.svg',
        alt: 'Level 30 Wizards',
    },
};
